import { put, call, takeLatest, select } from 'redux-saga/effects';
import { fetchMessages, getEngagements } from 'src/services/messages.service';
import { getFilters } from 'src/ui/features/Messaging/state/messagingReselect';
import * as messagingActions from './messagingActions';
import * as messagingTypes from './messagingTypes';
import { validateToken } from '../../Login/state/loginSaga';
import { push } from 'connected-react-router';
import { LOGIN_URL, MESSAGEDETAIL_TYPES } from '../../../../constants/constants';

export function* applyFilterSaga({ payload }) {
  try {
    const selectedMenu = yield select(state => state.messaging.selectedMenu);
    const filters = yield select(getFilters);
    const caseManagerId = yield select(state => state.cases.caseManagerId);
    if (caseManagerId) {
      filters['caseManagerId'] = caseManagerId;
    }
    const personId = yield select(state => state.login.userInfo.personId);
    const data = yield call(fetchMessages, selectedMenu, { ...filters, ...payload }, personId);
    yield put(messagingActions.applyFiltersSuccess());
    yield put(messagingActions.toggleModal(false));
    yield put(messagingActions.getMessagesSuccess(selectedMenu, data));
  } catch (error) {
    yield put(messagingActions.applyFiltersFailure(error));
  }
}

export function* getOrderedData() {
  try {
    const selectedMenu = yield select(state => state.messaging.selectedMenu);
    const filters = yield select(getFilters);
    const caseManagerId = yield select(state => state.cases.caseManagerId);
    if (caseManagerId) {
      filters['caseManagerId'] = caseManagerId;
    }
    const personId = yield select(state => state.login.userInfo.personId);
    const data = yield call(fetchMessages, selectedMenu, { ...filters, personId });
    yield put(messagingActions.applyFiltersSuccess());
    yield put(messagingActions.toggleModal(false));
    yield put(messagingActions.getMessagesSuccess(selectedMenu, data));
  } catch (error) {
    yield put(messagingActions.applyFiltersFailure(error));
  }
}

export function* clearFilterSaga() {
  try {
    const selectedMenu = yield select(state => state.messaging.selectedMenu);
    const data = yield call(fetchMessages, selectedMenu);
    yield put(messagingActions.clearFiltersSuccess());
    yield put(messagingActions.toggleModal(false));
    yield put(messagingActions.getMessagesSuccess(selectedMenu, data));
  } catch (error) {
    yield put(messagingActions.applyFiltersFailure(error));
  }
}

export function* loadEngagements() {
  try {
    const engagementsData = yield call(getEngagements);
    const engagements = (engagementsData.success && engagementsData.messages) || [];
    yield put(messagingActions.loadEngagementsSuccess(engagements));
  } catch (error) {}
}

export function* checkStatus() {
  const status = yield call(validateToken);
  if (!status) {
    yield put(push(LOGIN_URL));
  }
}

export function* cleanComposeData(action) {
  yield put(messagingActions.selectDetailView(MESSAGEDETAIL_TYPES.VIEWMESSAGE));
}

// export function* runMessagingMonitorSaga() {
//   return yield put(messagingActions.runMessagingMonitor());
// }

const messagingSaga = [
  takeLatest(messagingTypes.APPLY_FILTERS_PENDING, applyFilterSaga),
  takeLatest(messagingTypes.CLEAR_FILTERS_PENDING, clearFilterSaga),
  takeLatest(messagingTypes.CHANGE_SORT_ORDER, getOrderedData),
  takeLatest(messagingTypes.ENGAGEMENT_LOAD_PENDING, loadEngagements),
  takeLatest(messagingTypes.CHECK_STATUS, checkStatus),
  //takeLatest(loginTypes.USER_VALIDATE_SUCCESS, runMessagingMonitorSaga),
  takeLatest(messagingTypes.SWITCH_VIEW, cleanComposeData),
];

export default messagingSaga;
